









import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import PicUpload from "@/components/picUpload/index.vue";
@Component({
  name: "imageSetting",
  components: {
    questionSettingTemplate,
    PicUpload,
  },
})
export default class imageSetting extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
    }
  }
  private postForm = {
    text: "",
  };

  private rules = {
    text: [{ required: true, message: "请输入描述说明", trigger: "blur" }],
  };
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  async validate() {
    return await this.getFormInstance()
      .validate()
      .catch((err: any) => {
        return err;
      });
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
}
